export default __webpack_public_path__ + "static/img/collections-coats-bg.43f566f.jpg";